export default "__VITE_ASSET__HagxcovO__"